import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 500px;
`

export const IconContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`

export const TextContainer = styled.div`
  font-size: 14px;
`